// common/components/Can.jsx
import { useContext } from 'react';
import { AuthContext } from '../common/constants';

export default function Can({ perm, anyOf = [], children }) {
  const { currentUser } = useContext(AuthContext);
  const perms = new Set(currentUser?.permissions || []);
  const okOne = anyOf.length ? anyOf.some(p => perms.has(p)) : true;
  const okSingle = perm ? perms.has(perm) : true;
  return (okOne && okSingle) ? children : null;
}
